import React from 'react';

const GridCTA = () => {
    return (
        <section className="backlight-top">
            <div className="infocolors-bento-grid infocolors-grid-cta">
                <div className="is-large infocolors-masked-block" data-appear="fade-right" data-unload="fade-left">
                    <div className="infocolors-grid-cta-media infocolors-masked-media" data-bg-src="img/cta/grid-cta-background.jpg">
                        <div className="infocolors-grid-cta-heading">Need a session with us?</div>
                    </div>
                    <div className="infocolors-masked-content at-bottom-right">
                        <p className="infocolors-large-text" data-appear="fade-right" data-delay="100">Let's chat about your goals &rarr;</p>
                    </div>
                </div>
                <div className="is-medium infocolors-block" data-appear="fade-down" data-unload="fade-right">
                    <h3>We have a dedicated team of creatives waiting to bring your dreams to life.</h3>
                </div>
                <div className="is-small" data-appear="zoom-out" data-delay="100" data-unload="zoom-out">
                    <a href="/contact" className="infocolors-square-button">
                        <span className="infocolors-icon infocolors-icon-explore"></span>
                    </a>
                </div>
                <div className="is-small" data-appear="zoom-out" data-delay="200" data-unload="zoom-out">
                    <img src="img/cta/grid-cta-02.jpg" alt="Let's Chat" width="960" height="960" />
                </div>
            </div>
        </section>
    );
};

export default GridCTA;
